import { node } from "~/util/dom";
import { IRibbonItemPhotoData } from "./interfaces";
import { WIDTH_PHOTO } from "./const";

interface IRibbonItemPhoto extends IRibbonItemPhotoData {
	width?: number;
	onClick?: () => void;
}

export type TMatrixType = "one-line-dyn-width" | "two-lines-dyn-width";

export default class RibbonItemPhoto {
	_data: IRibbonItemPhoto;

	_dom: {
		container: HTMLAnchorElement;
	};

	constructor(data: IRibbonItemPhoto) {
		this._data = {
			width: WIDTH_PHOTO,
			onClick: () => {},
			...data,
		};

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	get isPortrait() {
		return this._data.imageHeight > this._data.imageWidth;
	}

	get width() {
		return this._data.width;
	}

	get data() {
		return this._data;
	}

	setMatrixType(type: TMatrixType, perc: number, gap: number) {
		/* eslint-disable-next-line */
		const percStr = (perc * 100).toFixed(2);

		this._dom.container.classList.add(type);
		this._dom.container.style.flex = `0 0 calc(${percStr}% - ${gap.toFixed(1)}px)`;
	}

	_build() {
		const container = node("a", { className: "ribbonItemPhoto", href: this._data.link });
		const image = node("img", { className: "ribbonItemPhoto__image" });

		image.addEventListener("load", () => {
			container.append(image);
		});
		image.src = this._data.imageSrc;

		this._dom = {
			container,
		};
		container.addEventListener("click", event => {
			event.stopPropagation();
			event.preventDefault();
			this._data.onClick();
		});
	}
}
